/* eslint-disable @typescript-eslint/no-unused-vars */

export const rowStyle = ({ palette = {} }) => ({
  '& .flex-row': {
    '&.aggregated-row': {
      '& .dragger': {
        visibility: 'hidden !important',
      },
    },

    '& .grid-edit-icon:focus': {
      opacity: 1,
    },
    '&[data-key]:hover': {
      background: '#f4f4f4',
      '& .td': {
        borderRight: `1px solid ${palette.white}`,
      },
    },
    '&:hover': {
      '& .grid-edit-icon': {
        opacity: 1,
      },
      '& .flex-cell[data-column=Status] .iconba-ChevronDown': {
        opacity: 1,
      },
    },
  },
});
